module.exports = __webpack_public_path__ + "static/flux-wireframe-3-bf222cc2161eb351c926dcf381bd9730.png";